// extracted by mini-css-extract-plugin
export default {"menuItem":"ButtonImageColor_menuItem__1xCbz","controls":"ButtonImageColor_controls__Wdyni","dropdown":"ButtonImageColor_dropdown__bD7AR","wrapper":"ButtonImageColor_wrapper__YmYVL"};